import React, { useContext } from 'react'
import './index.scss'
import { StoresContext } from '@App/contexts'
import { stringEscapeNewlines } from '@App/helpers/string-escape-newlines'
import { WorkModel } from '@Entities/work/work'
import { SelectOption } from '@Components/Selectors/Select'
import { ZodFormattedError } from 'zod'
import { formatLanguage } from '@App/helpers/format-language'
import { tableCellSanitizer } from '@App/helpers/table-cell-sanitizer'
import { AlternativeTitleModel } from '@Entities/work/alternative-title-model'

interface AlternativeTitlesTableProps {
    viewWork: WorkModel
    errors: ZodFormattedError<AlternativeTitleModel[], string> | undefined
}

const AlternativeTitlesTable = ({ viewWork, errors }: AlternativeTitlesTableProps) => {
    const { libStore } = useContext(StoresContext)
    const langOptions = libStore.languages
    const titleTypes = libStore.akaTitleTypes
    const formatTitleType = (titleType: number | null) =>
        titleTypes.find((type: SelectOption) => +type.id === titleType)?.label

    return (
        <div className="alternative-titles-table-container">
            <h5>Alternative Titles</h5>
            {viewWork.alternativeTitles.length > 0 ? (
                <div className="container">
                    <table className="alternative-titles-table">
                        <thead>
                            <tr>
                                <th>Alternative Title</th>
                                <th>Alternative Title Type</th>
                                <th>Language</th>
                            </tr>
                        </thead>

                        <tbody>
                            {viewWork.alternativeTitles.map((altTitle, idx) => (
                                <tr key={idx}>
                                    <td>{stringEscapeNewlines(altTitle.title)}</td>
                                    <td>{tableCellSanitizer(formatTitleType(altTitle.titleType))}</td>
                                    <td>{tableCellSanitizer(formatLanguage(langOptions, altTitle.languageCode))}</td>

                                    {errors?.[idx]?.title?._errors[0] && (
                                        <td className="error-field">{errors?.[idx]?.title?._errors?.join(', ')}</td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <span className="no-alternative-titles-label">No Alternative Titles</span>
            )}
        </div>
    )
}

export default AlternativeTitlesTable
